import {mapGetters, mapActions} from 'vuex';
import {inApp, isIos} from 'common/constant';
// import mlinkAdpt from 'common/service/mlink-adpt';
import * as api from 'common/service/server-api';
import LazyLoadImg from 'common/component/lazy-load-img';

export default {
    data() {
        return {
            inApp,
            isIos
        }
    },
    created() {
        this.init({id: this.$route.params.id, messageFrom: this.$route.query.messageFrom});
    },
    methods: {
        initLazyLoadImg() {
            if(!this.lazyLoadImg) {
                this.lazyLoadImg = new LazyLoadImg({
                    el: this.$el,
                    done: true,
                    time: 200
                });
            }
        },
        destroyLazyLoadImg() {
            if(this.lazyLoadImg && this.lazyLoadImg.destroy) {
                this.lazyLoadImg.destroy();
                this.lazyLoadImg = null;
            }
        },
        openApp() {
            api.getMoreNewsAction();
            if(this.inApp) {
                JSAPI = window.JSAPI;
                if(JSAPI.openByApp4EMUI6) {
                    JSAPI.openByApp4EMUI6('cn.peopletech.news', 'mwpeopletechnews://host?page=home', '1', '100224833');
                } else if(JSAPI.openByApp) {
                    JSAPI.openByApp('cn.peopletech.news', 'mwpeopletechnews://host?page=home');
                }
            }
        },
        setMlinkOptions() {
            const btns = this.$el.querySelectorAll('.open-app');
            const options = [];
            for(let i = 0; i < btns.length; i++) {
                options.push({
                    button: btns[i],
                    params: {
                        page: 'home'
                    }
                });
            }
            // mlinkAdpt.setOptions(options);
        }
    }
}




// WEBPACK FOOTER //
// ./src/common/mixin/page-base.js